export default __webpack_public_path__ + "static/media/ChakraPetch-SemiBold.5f67cd3d.woff";